import React, { lazy, Suspense, useState } from 'react';
import styled from 'astroturf/react';
import { ShareButtons } from 'js/journals/ShareButtons';

const WechatQRCode = lazy(() => import('js/journals/WechatQRCode'));

const WechatPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs-8, 8px);
  margin-top: var(--spacing-sm-24, 24px);
  text-align: center;
`;

type Props = Omit<
  React.ComponentProps<typeof ShareButtons>,
  'onWechatShare' | 'wechatExpanded' | 'whatsappUrl' | 'redditUrl'
> & {
  articleUrl: string | null;
};

const ArticleShareButtons: React.FC<Props> = ({ articleUrl, ...props }) => {
  const [showWechat, setShowWechat] = useState(false);
  const wechatUrl = articleUrl ? new URL(articleUrl) : null;
  wechatUrl?.searchParams.set('src', 'wechat');

  return (
    <>
      <ShareButtons
        {...props}
        onWechatShare={
          wechatUrl ? () => setShowWechat((shown) => !shown) : undefined
        }
        wechatExpanded={showWechat}
        whatsappUrl={articleUrl ?? undefined}
        redditUrl={articleUrl ?? undefined}
      />
      {showWechat && wechatUrl && (
        <WechatPanel>
          <Suspense fallback={<p role="status">Loading QR code…</p>}>
            <WechatQRCode paperUrl={wechatUrl.toString()} />
          </Suspense>
          <p>Scan with WeChat to open this article, then share it in WeChat.</p>
        </WechatPanel>
      )}
    </>
  );
};

export default ArticleShareButtons;
